import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import Sidebar from '../Sidebar/Sidebar';
import routes from '../../Routes/Routes';
import ProtectedRoute from '../ProtectedRoute/ProtectedRoute';

function Layout() {
  return (
    <div className="Layout">
      <div className="abc">
        <Sidebar />
      </div>
      <div className="def">
        <Header />
        <div className="ContentWrapper">
          <Routes>
            {routes.map((route) => (
              route.protected ? (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    <ProtectedRoute route={route}>
                      <route.component />
                    </ProtectedRoute>
                  }
                />
              ) : (
                <Route
                  key={route.path}
                  path={route.path}
                  element={<route.component />}
                />
              )
            ))}

            {/* Fallback for unauthorized access */}
            <Route path="/unauthorized" element={<>Unauth</>} />

            {/* Fallback for unmatched paths */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default Layout;
